import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink, RouterLinkActive, RouterOutlet, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-formations-management',
  templateUrl: './formations-management.component.html',
  styleUrl: './formations-management.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTabNav, MatTabLink, MatTabNavPanel, RouterLink, RouterLinkActive, RouterOutlet],
})
export class FormationsManagementComponent {
  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  readonly nav_links = [
    { label: 'Catálogo', link: './catalog' },
    { label: 'Por usuario', link: './by-user' },
  ];
}
